module.exports = __webpack_public_path__ + "img/c6e467847dd3da1dfc7517fc6fba5617.png";